// ** Icons Import
import { Box, Truck } from 'react-feather'

export default [
  {
    header: 'Special Orders',
    resource: 'orders',
    action: 'read'
  },
  /*{
    id: 'calendar',
    title: 'Calendar',
    icon: <Calendar size={20} />,
    navLink: '/calendar'
  },*/
  {
    id: 'special-orders',
    title: 'Cars',
    icon: <Truck size={20} />,
    navLink: '/special-orders/cars',
    resource: 'orders',
    action: 'read'
  },
  {
    id: 'chines-cars',
    title: 'Chines Cars',
    icon: <Truck size={20} />,
    navLink: '/chines-cars',
    resource: 'special_orders',
    action: 'read'
  },
  {
    id: 'special-orders-boxes',
    title: 'Boxes',
    icon: <Box size={20} />,
    navLink: '/special-orders/boxes',
    resource: 'orders',
    action: 'read'
  }
]
